import { render, staticRenderFns } from "./CommentListItem.vue?vue&type=template&id=c39a2320&scoped=true&"
import script from "./CommentListItem.vue?vue&type=script&lang=js&"
export * from "./CommentListItem.vue?vue&type=script&lang=js&"
import style0 from "./CommentListItem.vue?vue&type=style&index=0&id=c39a2320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a2320",
  null
  
)

export default component.exports